import cx from 'classnames';
import pluralize from 'pluralize';
import { useState } from 'react';
import { AddIcon } from 'tombac-icons';
import OrganizationAddForm from "./OrganizationAddForm";
import "./OrganizationChildrenSummary.css";
import { OrganizationButton } from "./OrganizationShared";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function OrganizationChildrenSummary(_ref) {
  let {
    className,
    disableAdd = false,
    onChange,
    org,
    ...rest
  } = _ref;
  const [orgFormVisible, setOrgFormVisible] = useState(false);
  return /*#__PURE__*/_jsxs("span", {
    className: cx('OrganizationChildrenSummary', className),
    ...rest,
    "data-sentry-component": "OrganizationChildrenSummary",
    "data-sentry-source-file": "OrganizationChildrenSummary.tsx",
    children: [(!disableAdd || org.children.length > 0) && pluralize('organization', org.children.length, true), /*#__PURE__*/_jsxs("span", {
      className: "OrganizationChildrenSummary__add",
      children: [!disableAdd && /*#__PURE__*/_jsx(OrganizationButton, {
        onClick: () => setOrgFormVisible(true),
        shape: "circle",
        title: "Add organization",
        type: "button",
        children: /*#__PURE__*/_jsx(AddIcon, {})
      }), orgFormVisible && /*#__PURE__*/_jsx(OrganizationAddForm, {
        nameInputProps: {
          onBlur: () => setOrgFormVisible(false),
          onKeyUp: event => event.key === 'Escape' && setOrgFormVisible(false)
        },
        parentOrg: org,
        onAdd: () => {
          setOrgFormVisible(false);
          if (onChange) onChange();
        }
      })]
    })]
  });
}